$(document).ready(function () {

  $(".image-preview").each(function( index ) {
    if ($(this).attr("src") === "") {
      $(this).css("border", "none");
    }
  });
});
